import {Component} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import Localization from 'src/smoothr-web-app-core/models/Localization';

@Component({
	selector: 'app-info-modal-second-view',
	templateUrl: './info-modal-second-view.component.html',
	styleUrls: ['./info-modal-second-view.component.scss']
})
export class InfoModalSecondViewComponent {
	title: string;
	subtitle: string;
	constructor(
		private modalCtrl: ModalController,
		private translate: TranslateService
	) {}

	static async show(modalCtrl: ModalController, title: string, subtitle: string): Promise<void> {
		const modal = await modalCtrl.create({
			component: InfoModalSecondViewComponent,
			cssClass: 'favourite-modal-on-add auto-height',
			componentProps: {
				title,
				subtitle
			},
			showBackdrop: true,
			backdropDismiss: true
		});
		await modal.present();
		await modal.onDidDismiss();
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}
}
